import actionTypes from './actionTypes';

export const requestTypes = {
  similar: actionTypes.SET_POSTFLOP_SIMILAR,
  situation: actionTypes.SET_POSTFLOP_SITUATION,
  combo: actionTypes.GET_COMBO,
  nextCombo: actionTypes.GET_NEXT_COMBO,
  resultsStat: actionTypes.GET_POSTFLOP_RESULTS_STAT,
};

const configurationTypes = [
  actionTypes.SET_DEFAULT, actionTypes.SET_TABLE_SIZE, actionTypes.SET_STACK_SIZE,
  actionTypes.SET_POSITION_TYPE, actionTypes.SET_POSITION,
  actionTypes.SET_RESULTS_POSITION_TYPE, actionTypes.SET_RESULTS_PFR_TYPE,
  actionTypes.SET_RESULTS_PLAYER_POSITION, actionTypes.SET_RESULTS_POSITION,
  actionTypes.SET_RESULTS_PREVIOUS_ACTION, actionTypes.SET_BOARD_SUIT,
  actionTypes.SET_BOARD_TYPE, actionTypes.SET_PAGE_MODE,
  actionTypes.SET_SELECTED_HIGH_CARD, actionTypes.SET_HIGH_LOW,
];

export const invalidatesRequest = (kind, action) => {
  if (configurationTypes.includes(action.type)) return true;
  if (action.type === `${requestTypes[kind]}_RESET`) return true;
  if (kind === 'resultsStat') return false;
  if (action.type === actionTypes.SET_SELECTED_BOARD) return true;
  if (kind !== 'situation' && action.type === actionTypes.SET_SELECTED_HAND_TYPE) return true;
  if (kind === 'similar') {
    return action.type === actionTypes.SET_SEARCH_VALUE
      || (action.type === actionTypes.SET_SELECTED_CARDS && !action.payload?.length)
      || (action.type === `${actionTypes.SET_SIMILAR_RESPONSE}_SUCCESS`
        && !action.meta?.postflopRequest && !action.payload?.data);
  }
  if (kind === 'situation') {
    return action.type === `${actionTypes.SET_BOARD_SITUATION}_SUCCESS`
      && !action.meta?.postflopRequest && !action.payload?.length;
  }
  return (action.type === actionTypes.SET_GAME_STARTED && action.payload === false
      && !action.meta?.postflopRequest)
    || (kind === 'nextCombo' && (action.type === actionTypes.CLEAR_NEXT_COMBO
      || action.type === actionTypes.GET_COMBO));
};

export const resultsStatKey = (payload = {}) => JSON.stringify([
  Boolean(payload.isPlo5), payload.game, payload.bb, payload.position_type,
  payload.position, payload.board_type, payload.hand_combo_type || '',
]);

export const getRequestRevision = (kind) => (state) => (
  state.postflop.requests?.[kind]?.revision || 0
);

export const requestMeta = (kind, revision) => ({ postflopRequest: { kind, revision } });

export const isCurrentRequest = (kind, revision) => (state) => (
  getRequestRevision(kind)(state) === revision
);
